import React from "react";
import ReactDOM from "react-dom";
import Dropdown from "./Dropdown";


/**
 * Edit-in-place behavior for form components
 * @module IntentListItemEditor
 * @param {Object} props React props
 */
export default class IntentListItemEditor extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            listItemConfig: {}
        };
        this.clickOutsideHandler = this.handleClickOutside.bind(this);
    }

    /**
     * Get reference to context menu container itself
     * @returns {jQuery}
     */
    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    componentDidMount(){
        document.addEventListener('mousedown', this.clickOutsideHandler);
    }

    componentWillUnmount(){
        document.removeEventListener('mousedown', this.clickOutsideHandler);
    }

    /**
     * Set the React reference of itself
     * @param {Object} node React node reference
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    
    /**
     * Hide itself if mouse click outside the boundary
     * @param {Object} event React event
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.context.onEditComplete();
        }
    }

    render(){
      
        return(
            <div 
                style={{'position': 'absolute', 'top': this.props.top, 'left': this.props.left, 'width' : this.props.width}}
                ref={this.setWrapperRef.bind(this)}
            >
                <Dropdown wide={false} 
                    options={this.props.options}
                    context={this.props.context} 
                    valKey={"editMapping"}
                    selection={this.props.selection}
                    optionName={window.l.library.modules}
                    notifyAfterClose={true} />                    
            </div>
        );

    }

}
